import { useEffect } from "react";
import { useSelector } from "react-redux";
import { makeAjax, url, respStatus, showMessage, extractScriptAttributes } from "../../helpers/global_helper";

const ChatConfig = ({ setChatLink }) => {
  const { playerProfile } = useSelector((state) => ({
    playerProfile: state.playerProfileR?.data ?? {},
  }));

  const removeExistingIframe = () => {
    const existingIframe = document.getElementById("chatboxframe2");
    if (existingIframe) existingIframe.remove();
  };


  useEffect(() => {
    console.log('ChatConfig playerProfile', playerProfile?.username);
    if (localStorage.getItem("user_token") && playerProfile?.username == '')
      return;
    let scriptElement;
    makeAjax(url.USER_API.getLiveChatConfig, [], url.USER_MS_EXT).then((response) => {
      if (response?.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }


      if (!response?.data) {
        console.log("No scritp found");
        return;
      }
      const { script } = response?.data ?? {};

      if (!script) console.log("Script not found in response.");

      const { src, id } = extractScriptAttributes(script);

      const scriptKey = response?.data?.hash_key;

      const storedToken = localStorage.getItem("user_token");
      const username = ((storedToken && playerProfile && playerProfile?.username && playerProfile?.username != '') ? playerProfile?.username : "guest");

      let modifiedURL = src.replace("api2?data=guest", `api2?data=${username}`);
      modifiedURL = modifiedURL.replace(/key=[^&]*/, `key=${scriptKey}`);

      if (localStorage.getItem("device_type") === "mobile" && setChatLink != 'undermaintenace') {
        const mobileChatLink = modifiedURL.replace(`api2?data=${username}`, `chatapi?user=${username}`);
        setChatLink(mobileChatLink);
      }
      else {
        removeExistingIframe();
        scriptElement = document.createElement("script");
        scriptElement.src = modifiedURL;
        scriptElement.id = id;

        const titleElement = document.getElementById("title");
        if (titleElement) {
          titleElement.before(scriptElement);
        } else {
          console.warn('Missing title or script element');
        }
      }
    });

    return () => {
      if (scriptElement) scriptElement.remove();
    };
  }, [playerProfile]);

  return null;
};

// Return
export { ChatConfig };
